import React, {useEffect, useState} from "react";
import {motion} from "framer-motion";
import {loaderBallImage} from "../../Utils/embedImages";
import {PreviewVideo} from "../../Interfaces/PreviewData";
var pluralize = require('pluralize-ru');

interface PreviewCountdownCircleTimerProps {
    waitingChunk: PreviewVideo|null,
    animationDuration: number,
    size: number,
    strokeWidth: number,
    onComplete?: () => void,
}

const PreviewCountdownCircleTimer: React.FC<PreviewCountdownCircleTimerProps> = ({
                                                                                     waitingChunk= null,
                                                                                     animationDuration = 10,
                                                                                     size = 180,
                                                                                     strokeWidth = 12,
                                                                                     onComplete
                                                                                 }) => {
    const MAX_DURATION = 40;
    const [startPositionSeconds, setStartPositionSeconds] = useState<number>(MAX_DURATION);
    const [durationSeconds, setDurationSeconds] = useState<number>(MAX_DURATION);
    const [animatedPositionSeconds, setAnimatedPositionSeconds] = useState<number>(0);
    const [chunkId, setChunkId] = useState<string|undefined>('');

    const [svg, setSvg] = useState('');

    useEffect(() => {
        let positionSeconds = 0;
        if (typeof waitingChunk?.estimatedRenderTimeSeconds !== 'undefined') {
            if (MAX_DURATION - waitingChunk?.estimatedRenderTimeSeconds < 0) {
                positionSeconds = 0;
            } else {
                positionSeconds = MAX_DURATION - waitingChunk?.estimatedRenderTimeSeconds;
            }
        }

        let startPositionSecondsTmp = startPositionSeconds;
        if (waitingChunk?.id !== chunkId) {
            setChunkId(waitingChunk?.id);
            // @ts-ignore
            if (typeof waitingChunk?.estimatedRenderTimeSeconds !== 'undefined') {
                if (MAX_DURATION - waitingChunk?.estimatedRenderTimeSeconds < 0) {
                    startPositionSecondsTmp = 0;
                } else {
                    startPositionSecondsTmp = MAX_DURATION - waitingChunk?.estimatedRenderTimeSeconds;
                }
            }
            startPositionSecondsTmp = startPositionSecondsTmp * 0.8;
            setStartPositionSeconds(startPositionSecondsTmp);
        }

        // @ts-ignore
        setSvg(getSvg(startPositionSecondsTmp, positionSeconds));
    }, [waitingChunk?.estimatedRenderTimeSeconds, waitingChunk, size])

    // @ts-ignore
    const getSvg = (startPositionSeconds, positionSeconds) => {
        const halfSize = size / 2
        const halfStrokeWith = strokeWidth / 2
        const arcRadius = halfSize - halfStrokeWith
        const arcDiameter = Math.abs(2 * arcRadius);
        const arcDiameter2 = - Math.abs(arcDiameter);
        const rotationIndicator = 'clockwise' === 'clockwise' ? '1,0' : '0,1'

        const pathLength = 2 * Math.PI * arcRadius
        const path = `m ${halfSize},${halfStrokeWith} a ${arcRadius},${arcRadius} 0 ${rotationIndicator} 0,${arcDiameter} a ${arcRadius},${arcRadius} 0 ${rotationIndicator} 0,${arcDiameter2}`

        return <svg
            width={size} height={size} xmlns="http://www.w3.org/2000/svg">
            <path
                d={path}
                fill="none"
                stroke={'#ffffff'}
                strokeWidth={Math.round(size/15)}
            />
            <motion.path
                key={`motion.path-${waitingChunk?.id}`}
                d={path}
                fill="none"
                stroke={'#a75a9b'}
                strokeLinecap={'round'}
                strokeWidth={Math.round(size/15)}
                strokeDasharray={pathLength}
                strokeDashoffset={pathLength * (startPositionSeconds / durationSeconds)}
                animate={{
                    strokeDashoffset: pathLength * (positionSeconds / durationSeconds)
                }}
                transition={{
                    ease: "easeOut",
                    duration: positionSeconds == durationSeconds ? 1 : animationDuration
                }}
                onUpdate={(v) => {
                    if (v.strokeDashoffset !== undefined) {
                        // @ts-ignore
                        let animatedSeconds = Math.round(v?.strokeDashoffset / (pathLength / durationSeconds));
                        if (animatedSeconds === undefined ||
                            animatedSeconds < 0) {
                            animatedSeconds = 0;
                        }
                        setAnimatedPositionSeconds(animatedSeconds);
                    }
                }}
                onAnimationComplete={(v) => {
                    if (typeof onComplete === 'function') {
                        onComplete();
                    }
                }}
            />
        </svg>
    }

    return (
        <div className={'preview-countdown-circle-timer'}>
            <div
                style={{
                width: size,
                height: size
            }}>
                {svg}
                <div className={'text-container'}>
                    {
                        animatedPositionSeconds == 0 || isNaN(animatedPositionSeconds) || waitingChunk?.estimatedRenderTimeSeconds == 0?
                            <div className="timer">
                                <div className={'ball'}><img src={loaderBallImage}/></div>
                                <div className={'almost-ready'}>Почти готово</div>
                            </div>
                            :
                            <div className="timer">
                                <div className="value">{(durationSeconds - animatedPositionSeconds) < 0 ? 0 : (durationSeconds - animatedPositionSeconds)}</div>
                                <div className="seconds">
                                    {pluralize((durationSeconds - animatedPositionSeconds) < 0 ? 0 : (durationSeconds - animatedPositionSeconds), 'секунд', 'секунду', 'секунды', 'секунд')}
                                </div>
                            </div>
                    }
                </div>
            </div>
        </div>
    )
}

export default PreviewCountdownCircleTimer;